// extracted by mini-css-extract-plugin
module.exports = {"base":"Tag--base--1da7r","title":"Tag--title--3L1aD","imageWrapper":"Tag--imageWrapper--3b8Ii"};